import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import * as styles from './Switch.module.css'

function Switch({
  className,
  disabled,
  hasError,
  label,
  labelProps,
  qaName,
  tooltip,
  value,
  onChange,
}) {
  function handleChange(e) {
    onChange?.(e.target.checked)
  }

  const qaProps = getQaSelector({ value: qaName })

  const switchClassName = classNames(styles.switch, className, {
    [styles.checked]: value,
    [styles.disabled]: disabled,
    [styles.error]: hasError,
  })

  return (
    <FloatingTooltip
      content={tooltip}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <label {...qaProps} className={switchClassName}>
        <input
          checked={value}
          className={styles.input}
          disabled={disabled}
          type='checkbox'
          onChange={handleChange}
        />
        <span className={styles.bounding} />
        {label ? <Text {...labelProps}>{label}</Text> : null}
      </label>
    </FloatingTooltip>
  )
}

export default Switch
